import Big from "big.js";
import filenamify from 'filenamify';
import darken from "polished/lib/color/darken";
import lighten from "polished/lib/color/lighten";
import readableColor from "polished/lib/color/readableColor";
export const CoreUtils = {
    dates: {
        getWeekdayIndex(day) {
            switch (day) {
                case "Monday":
                    return 1;
                case "Tuesday":
                    return 2;
                case "Wednesday":
                    return 3;
                case "Thursday":
                    return 4;
                case "Friday":
                    return 5;
                case "Saturday":
                    return 6;
                case "Sunday":
                    return 7;
                default:
                    throw new Error("ERROR WEEKDAY");
                    return 0;
            }
        },
        getNextWeekday(day) {
            switch (day) {
                case "Sunday":
                    return "Monday";
                case "Monday":
                    return "Tuesday";
                case "Tuesday":
                    return "Wednesday";
                case "Wednesday":
                    return "Thursday";
                case "Thursday":
                    return "Friday";
                case "Friday":
                    return "Saturday";
                case "Saturday":
                    return "Sunday";
                default:
                    return "Monday";
            }
        },
        // tslint:disable-next-line
        getPreviousWeekday(day) {
            switch (day) {
                case "Sunday":
                    return "Saturday";
                case "Monday":
                    return "Sunday";
                case "Tuesday":
                    return "Monday";
                case "Wednesday":
                    return "Tuesday";
                case "Thursday":
                    return "Wednesday";
                case "Friday":
                    return "Thursday";
                case "Saturday":
                    return "Friday";
                default:
                    return "Monday";
            }
        },
        getMillisFromMinutes(minutes) {
            return 1000 * 60 * minutes;
        },
    },
    string: {
        remove_linebreaks: (str) => {
            return str.replace(/(\r\n\t|\n|\r\t)/gm, "");
        },
        replace_spaces: (string, replace) => {
            return string.replace(/ /g, replace);
        },
        cap_first: (string) => string.charAt(0).toUpperCase() + string.slice(1),
        replace_special_charaters: (input) => {
            return filenamify(input).replace(/[^a-zA-Z0-9.]|\.(?=.*\.)/g, '_');
        }
    },
    currency: {
        centsToDecimal(amount, precision) {
            const ratio = Math.pow(10, precision);
            return new Big(amount).div(ratio).toFixed(precision);
        },
        decimalToCents(amount, precision) {
            return parseInt(new Big(amount).times(Math.pow(10, precision)).toFixed(0), 10);
        },
        precision_to_step: (precision) => {
            if (precision === 0)
                return "1";
            if (precision === 1)
                return "0.1";
            if (precision === 2)
                return "0.01";
            if (precision === 3)
                return "0.001";
            if (precision === 4)
                return "0.0001";
            return "0.01";
        },
    },
    colors: {
        shadeAlternate(shade, color) {
            if (readableColor(color) === "#000") {
                return darken(shade, color);
            }
            else {
                return lighten(shade, color);
            }
        },
        stringFromRgba(obj) {
            return `rgba(${obj.r}, ${obj.g}, ${obj.b}, ${obj.a})`;
        },
        rgbaObjectFromString(string) {
            if (!string)
                return { r: 0, g: 0, b: 0, a: 1 };
            if (string.indexOf("rgba") !== -1) {
                const temp = (string.split("rgba(")[1]).slice(0, -1).split(",");
                return {
                    r: parseInt(temp[0], 10),
                    g: parseInt(temp[1], 10),
                    b: parseInt(temp[2], 10),
                    a: parseFloat(temp[3]),
                };
            }
            else {
                const temp = (string.split("rgb(")[1]).slice(0, -1).split(",");
                return {
                    r: parseInt(temp[0], 10),
                    g: parseInt(temp[1], 10),
                    b: parseInt(temp[2], 10),
                    a: 1,
                };
            }
        },
        rgbToHex(rgb) {
            if (!rgb)
                return 'FB2F2F';
            if (rgb.startsWith('#'))
                return rgb.toLocaleLowerCase().substring(1);
            const componentToHex = (c) => {
                const hex = c.toString(16);
                return hex.length == 1 ? '0' + hex : hex;
            };
            return rgb
                .replace(/^rgb?a\(((,?\s*\d+){3}).+$/, '$1')
                .split(', ')
                .map(c => componentToHex(Number(c)))
                .join('');
        },
    },
    image: {
        uc: (image, transformations) => {
            if (!image || !image._id)
                return undefined;
            if (image.not_uc) {
                return image._id;
            }
            let url = `https://ucarecdn.com/${image._id}`;
            if (image.modifiers) {
                url += `/${image.modifiers}`;
            }
            if (transformations) {
                for (const key in transformations) {
                    if (transformations.hasOwnProperty(key)) {
                        const value = transformations[key];
                        if (value === "scale_crop" || value === "crop") {
                            url += `/-/${key}/${value}/center`;
                        }
                        else {
                            url += `/-/${key}/${value}`;
                        }
                    }
                }
            }
            url += `/-/progressive/yes`;
            url = url + `/${image.name}`;
            return url;
        },
    },
    ui: {
        breakpoint(width) {
            if (width >= 1200)
                return "xl";
            else if (width >= 920)
                return "lg";
            else if (width >= 720)
                return "md";
            else if (width >= 480)
                return "sm";
            return "xs";
        },
        breakpoints: {
            xl: 1200,
            lg: 920,
            md: 720,
            sm: 480,
        },
    },
    fns: {
        wait(duration) {
            return new Promise((resolve) => {
                setTimeout(() => resolve(() => { }), duration);
            });
        },
    }
};
//# sourceMappingURL=index.js.map